import classNames from 'classnames';
import { Tooltip } from 'shared/ui/Tooltip';
import type { LogsSource } from 'entities/history';

interface SourceProps {
  source: LogsSource;
  className?: string;
}

export function Source({ className, source }: SourceProps) {
  if (source === 'ClientDashboard') {
    return (
      <Tooltip
        placement="bottom-start"
        content={<span className=" text-sm">Source: Client Dashboard</span>}
        widthClass="max-w-[220px]"
      >
        <div
          className={classNames(
            className,
            'px-2 py-1 text-xs text-slate-700 rounded-sm bg-slate-50 cursor-pointer w-fit'
          )}
        >
          CD
        </div>
      </Tooltip>
    );
  }

  return <></>;
}
